import React, { ReactNode, MouseEvent } from 'react';
import ListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

export interface ListItemButtonProps {
  isSelected?: boolean;
  onClick: () => void;
  onRemove?: () => void;
  children: ReactNode;
  className?: string;
}

export const ListItemButton = ({
  isSelected = false,
  onClick,
  onRemove,
  children,
  className,
}: ListItemButtonProps) => {
  const handleRemove = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onRemove?.();
  };

  return (
    <ListItem
      disablePadding
      className={className}
      sx={{
        borderRadius: '10px',
        overflow: 'hidden',
        mb: 0.5,
      }}
    >
      <MuiListItemButton
        selected={isSelected}
        onClick={onClick}
        sx={{
          borderRadius: '10px',
          px: 2,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          transition: 'all 0.2s ease',
          '&.Mui-selected': {
            bgcolor: 'primary.50',
            color: 'primary.main',
            '&:hover': {
              bgcolor: 'primary.100',
            },
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, minWidth: 0 }}>
          {children}
        </Box>

        {isSelected && onRemove && (
          <IconButton
            size="small"
            onClick={handleRemove}
            sx={{
              color: 'text.secondary',
              '&:hover': {
                color: 'error.main',
                bgcolor: 'error.50',
              },
            }}
          >
            <CancelRoundedIcon sx={{ fontSize: 18 }} />
          </IconButton>
        )}
      </MuiListItemButton>
    </ListItem>
  );
};

export default ListItemButton;
